<!--
 * @Description:
 * @Author: xz
 * @Date: 2023-10-31 16:18:05
 * @LastEditTime: 2024-08-22 08:51:02
 * @LastEditors: xz
-->
<template>
  <div id="container" class="management">
    <div class="left">
      <div class="table-box">
        <div>
          <div class="search-box">
            <el-input
              v-model="searchText"
              style="width: 50%"
              placeholder="通过文件名搜索"
            >
              <template #append>
                <el-button
                  class="button-search"
                  icon="el-icon-search"
                  @click="searchTree"
                />
              </template>
            </el-input>
            <el-popover placement="bottom" :width="400" trigger="click">
              <template #reference>
                <el-button
                  class="button-search"
                  type="primary"
                  icon="el-icon-setting"
                  @click="searchTree"
                />
              </template>
              <el-checkbox v-model="checkList.createName" label="创建人" />
              <el-checkbox v-model="checkList.creatTime" label="创建时间" />
              <el-checkbox v-model="checkList.fileSize" label="文件大小" />
            </el-popover>
          </div>
          <el-table
            ref="tableRef"
            :data="groupData"
            height="82vh"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            row-key="id"
            :expand-row-keys="['0']"
            :indent="13"
            border
            header-align="center"
            lazy
            @row-click="rowClick"
            :load="load"
          >
            <el-table-column
              label="文件名"
              :show-overflow-tooltip="true"
              min-width="200"
            >
              <template slot-scope="scope">
                {{ scope.row.fileName }}
                <!-- <span style="display:flex;align-items: center;">
                        <img v-if="scope.row.type==0" src="../../../static/file/huabanfuben.png"  alt="" class="file_image" />
                        <img v-else :src="setImage(scope.row.fileName)"  alt="" class="file_image" />
                        <span style="margin-left:2px">{{ scope.row.fileName }}</span>
                    </span> -->
              </template>
            </el-table-column>
            <el-table-column
              v-if="checkList.createName"
              label="创建人"
              align="center"
              width="90"
            >
              <template #default="scope">
                <span>{{ scope.row.createName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="checkList.creatTime"
              label="创建时间"
              align="center"
              min-width="120"
            >
              <template #default="scope">
                <span>{{ scope.row.creatTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="checkList.fileSize"
              label="文件大小"
              align="center"
              width="90"
            >
              <template #default="scope">
                {{ setSizeText(scope.row.fileSize) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="140">
              <template #default="scope">
                <el-tooltip content="文件预览" placement="top">
                  <el-button
                    v-if="scope.row.type == 1"
                    type="primary"
                    size="small"
                    icon="el-icon-view"
                    @click="checkRow(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="下载" placement="top">
                  <el-button
                    v-if="scope.row.type == 1"
                    type="warning"
                    size="small"
                    icon="el-icon-download"
                    @click="downFile(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="新建文件夹" placement="top">
                  <el-button
                    v-if="scope.row.type == 0"
                    type="primary"
                    size="small"
                    icon="el-icon-folder-add"
                    @click="showFolderAdd(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="文件上传" placement="top">
                  <el-button
                    v-if="scope.row.type == 0"
                    type="warning"
                    size="small"
                    icon="el-icon-document-add"
                    @click="showUploadFile(scope.row)"
                  >
                  </el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    @click="deleteShowFile(scope.row)"
                    icon="el-icon-delete"
                    type="danger"
                    size="small"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  :content="scope.row.isPutIn == 0 ? '录入知识库' : '已入库'"
                  placement="top"
                >
                  <el-button
                    v-if="scope.row.type == 1"
                    :type="scope.row.isPutIn == 0 ? 'success' : ''"
                    :disabled="scope.row.isPutIn == 1"
                    icon="el-icon-position"
                    size="small"
                    @click="putInFile(scope.row.id, scope.row.pid)"
                  >
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-dialog title="文件上传" :visible.sync="fileUpload" width="40%">
          <el-form ref="form" label-width="6rem">
            <el-form-item label="文件">
              <el-upload
                class="upload-demo"
                ref="uploadRef"
                action="#"
                :on-change="handleChange"
                :on-exceed="handleExceed"
                :multiple="false"
                :limit="1"
                :file-list="fileList"
                :on-success="handSuccess"
                :auto-upload="false"
              >
                <el-button slot="trigger" class="button-confrim"
                  >选取文件</el-button
                >
              </el-upload>
            </el-form-item>
          </el-form>
          <template #footer>
            <el-button class="button-cancel" @click="fileUpload = false"
              >取 消</el-button
            >
            <el-button class="button-confrim" @click="submitFile"
              >提交</el-button
            >
          </template>
        </el-dialog>
        <el-dialog :visible.sync="folder" title="新建文件夹" width="40%">
          <el-form ref="file.value" :model="file" label-width="6rem">
            <el-form-item label="文件夹名称:" prop="c_name">
              <el-input v-model="file.c_name" placeholder="文件夹名称" />
            </el-form-item>
          </el-form>
          <template #footer>
            <el-button class="button-cancel" @click="folder = false"
              >取 消</el-button
            >
            <el-button class="button-confrim" @click="submitFolder"
              >确 定</el-button
            >
          </template>
        </el-dialog>
      </div>
    </div>
    <div class="right">
      <div class="file-box">
        <div style="font-size: 20px; color: #000; margin-bottom: 2px">
          {{ title }}
        </div>
        <div v-if="iframeUrl == ''">
          <div></div>
        </div>
        <iframe
          v-else
          :src="iframeUrl"
          frameborder="0"
          style="width: 100%; height: 100%"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { findAllType, download } from "@/api/file";
import {
  addFileInfo,
  getDocumentTree,
  addFileDirectory,
  delFileDirectory,
  putInDocument,
  getDocumentsByParents,
  searchDocuments,
} from "@/api/docment";
import TagListVue from "./comp/TagList.vue";
import { TUP, fileUrl, KKFILEURL } from "../../../utils/baseUrl";
import { Base64 } from "js-base64";
// 默认第一页的id 为0
export default {
  components: { TagListVue },
  data() {
    return {
      title: "",
      fileItemList: [],
      iframeUrl: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      // url: PATH_URL + "file/fielpdf",
      token: sessionStorage.getItem("token"),
      formInline: {},
      tableData: [],
      checkFile: {},
      fileone: {},
      groupData: [],
      expandKeys: [],
      fileUrl: "",
      folder: false,
      file: {
        c_name: "",
      },
      getFileList: [],
      fileUpload: false,
      fileToUp: undefined,
      dirChoice: 0,
      fileList: [],
      searchText: "",
      currentParentId: 0,
      tableTreeRefreshTool: {},
      checkList: { fileSize: false, createName: false, creatTime: false },
    };
  },
  mounted() {
    // this.init();
    this.getTag();
    this.getFile();
  },
  methods: {
    // 新增tag重新去获取标签
    AddTag() {
      this.getTag();
    },
    getTag() {
      findAllType().then((res) => {
        if (res.data.code == 200) {
          this.tagList = res.data.data;
          res.data.data.forEach((element) => {
            this.tagListObject[element.id] = element.fileType;
          });
        }
      });
    },
    rowClick(row, column, e) {
      if (row.type == 0) {
        console.log("row", e);
        if (
          e.currentTarget.firstElementChild.firstElementChild.firstElementChild
            .tagName == "DIV"
        ) {
          e.currentTarget.firstElementChild.firstElementChild.firstElementChild.click();
        } else {
          e.currentTarget.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.click();
        }
      } else {
        this.checkRow(row);
      }
    },
    getFile() {
      getDocumentsByParents({ pid: 0, projectId: 0 }).then((res) => {
        // console.log(res, "res");
        const data = res.data.data;
        this.groupData = data;
        this.getFileList = this.groupData;
      });
    },
    load(tree, treeNode, resolve) {
      // 保存父级id，在你需要刷新子级数据的地方可以用到
      this.currentParentId = tree.id;
      // 在之前声明的全局变量中，增加一个key为 本条数据的id，id可替换为你数据中的任意唯一值
      this.tableTreeRefreshTool[tree.id] = {};
      // 重要！保存resolve方法，以便后续使用
      this.tableTreeRefreshTool[tree.id].resolve = resolve;
      // 记录展开次数，具体作用后续介绍
      this.tableTreeRefreshTool[tree.id].expandCount = 0;
      getDocumentsByParents({ pid: tree.id }).then((res) => {
        resolve(res.data.data);
      });
    },
    handleExpandChange(row, expanded) {
      // 获取到之前保存的全局变量
      const curr = this.tableTreeRefreshTool[row.id];
      // 展开次数 +1
      curr.expandCount++;
      // 如果是展开状态，且展开次数大于1，且上一次的状态为折叠，则请求api数据，更新子菜单
      if (expanded && curr.expandCount > 1 && !curr.prevStatus) {
        // api请求
        getDocumentsByParents({ pid: row.id }).then((res) => {
          curr.resolve(res.data.data);
        });
      }
      // 保存本次的展开或折叠状态，用于下次判断
      curr.prevStatus = expanded;
    },
    //刷新子集数据
    reSetChildren(id) {
      if (id == 0) {
        this.getFile();
      } else if (this.tableTreeRefreshTool[id] != undefined) {
        const curr = this.tableTreeRefreshTool[id];
        getDocumentsByParents({ pid: id }).then((res) => {
          let data = res.data.data;
          if (data.length == 0) {
            this.$refs.tableRef.store.states.lazyTreeNodeMap[id] = [];
          } else {
            curr.resolve(res.data.data);
          }
        });
      }
    },
    searchTree() {
      if (this.searchText == null || this.searchText == "") {
        this.getFile();
      } else {
        searchDocuments({ searchText: this.searchText, projectId: 0 }).then(
          (res) => {
            // console.log(res, "res");
            const data = res.data.data;
            this.groupData = data;
            // this.getFileList = this.groupData;
          }
        );
      }
    },
    //删除文件
    deleteShowFile(data) {
      this.$confirm("确定要删除这个文件", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delFileDirectory({ id: data.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("删除成功");
              this.reSetChildren(data.pid);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    setSizeText(size) {
      if (size == null) {
        return "";
      } else if (size < 1024) {
        return size.toFixed(2) + "B";
      } else if (size < 1048576) {
        return (size / 1024).toFixed(2) + "KB";
      } else if (size < 1073741824) {
        return (size / 1048576).toFixed(2) + "MB";
      }
    },
    showFolderAdd(row) {
      this.dirChoice = row.id;
      this.file.name = "";
      this.folder = true;
    },
    //显示上传文件弹窗
    showUploadFile(row) {
      this.fileToUp = undefined;
      this.dirChoice = row.id;
      console.log(row, "showUploadFile");
      this.fileUpload = true;
      // uploadRef.value.clearFiles()
    },
    // 新增文件夹
    submitFolder() {
      let params = {
        pid: this.dirChoice,
        dirName: this.file.c_name,
        fileName: this.file.c_name,
      };
      addFileDirectory(params).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data,
            type: "success",
          });
          this.folder = false;
          this.reSetChildren(this.dirChoice);
        } else {
          this.$message({
            message: res.data,
            type: "error",
          });
        }
      });
    },
    handleChange(file, fileList) {
      this.fileToUp = file;
    },
    handSuccess(response, file, fileList) {
      // this.$refs.uploadRef.clearFiles()
    },
    handleExceed(files, uploadFiles) {
      this.fileList = [];
      let item = files[0];
      let file = {
        name: item.name,
        percentage: 0,
        raw: item,
        size: item.size,
        status: "ready",
        uid: genFileId(),
      };
      this.fileToUp = file;
      this.fileList.push(file);
      // this.fileToUp = files[0];
    },
    //上传文件
    submitFile() {
      if (this.fileToUp == undefined) {
        this.$message({
          message: "请先选择文件",
          type: "warning",
        });
      }
      let formData = new FormData();
      let id = this.dirChoice;
      formData.append("file", this.fileToUp.raw);
      // formData.append("remark", this.form.remark == undefined || this.form.remark == null ? "" : this.form.remark);
      formData.append("pid", id);
      addFileInfo(formData).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "上传成功",
            type: "success",
          });
          this.putInFile(res.data.data.id, res.data.data.pid);
          this.reSetChildren(this.dirChoice);
          this.fileUpload = false;
        } else {
          this.$message({
            message: "上传失败,请检查文件是否已上传",
            type: "error",
          });
        }
      });
    },
    putInFile(id, pid) {
      this.$confirm("是否将该文件录入知识库", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          putInDocument({ id: id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "录入成功",
              });
              this.reSetChildren(pid);
            } else {
              this.$message({
                type: "error",
                message: "录入失败",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作",
          });
        });
    },
    checkRow(data) {
      var url = fileUrl + data.fileUrl; //要预览文件的访问地址
      //   var url = fileUrl + "pdfpath/1690979772085.jpg"; //要预览文件的访问地址
      //   console.log("url", url,KKFILEURL);
      this.title = data.fileName;
      this.iframeUrl =
        KKFILEURL +
        "/onlinePreview?url=" +
        encodeURIComponent(Base64.encode(url));
      // this.fileShow = true;
    },
    //下载文件
    downFile(data) {
      let params = {
        fileName: data.fileName,
        fileUrl: data.fileUrl,
      };
      download(params).then((res) => {
        let blob = new Blob([res.data]);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = data.fileName;
        link.click();
        URL.revokeObjectURL(url);
      });
    },
    setImage(data) {
      if (
        data.includes(".png") ||
        data.includes(".jpg") ||
        data.includes(".jepg")
      ) {
        return require("../../../static/file/tupian.png");
      } else if (data.includes(".docx") || data.includes(".doc")) {
        return require("../../../static/file/zhanbeizhishou-word.png");
      } else if (data.includes(".xlsx") || data.includes(".xls")) {
        return require("../../../static/file/t_excelwenjian.png");
      } else if (data.includes(".pdf")) {
        return require("../../../static/file/Pdf.png");
      } else if (data.includes(".ppt")) {
        return require("../../../static/file/PPT.png");
      } else if (data.includes(".mp4")) {
        return require("../../../static/file/mp4.png");
      } else if (data.includes(".txt")) {
        return require("../../../static/file/txt.png");
      } else if (data.includes(".json")) {
        return require("../../../static/file/JSON.png");
      } else if (data.includes(".caj")) {
        return require("../../../static/file/CAJ.png");
      } else if (data.includes(".flv")) {
        return require("../../../static/file/flv.png");
      } else if (data.includes(".mp3")) {
        return require("../../../static/file/MP.png");
      } else if (data.includes(".docx")) {
        return require("../../../static/file/docx.png");
      }
    },
  },
};
</script>

<style scoped>
#container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 99%;
  height: 98%;
  padding: 0.5rem 0.25rem;
  overflow: hidden;

  ::-webkit-scrollbar {
    display: none;
  }
  /* .el-table {
    .cell{
        display:flex;
        justify-content: safe;
        align-items: center;
    }
  } */
}
.table-box {
  height: 100%;
  padding: 0 2% 0 0.125rem;
}
.left {
  width: 49%;
  height: 98%;
  padding: 1rem 0 0 1rem;
  border-radius: 1rem;
  /* border: 1px rgba(9, 33, 149, 0.842) solid; */
  box-shadow: 0 0 3px rgb(46, 43, 43);
}
.search-box {
  /* padding: 0 2%; */
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-bottom: 0.0125rem solid;
}
.header_left {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.header_back {
  display: flex;
  align-items: center;
  padding-right: 0.125rem;
  border-right: 0.025rem solid rgba(0, 128, 192, 0.5);
  cursor: pointer;
}
.header_page {
  padding-left: 0.125rem;
}
.header_content {
  display: flex;
}
.upload-demo {
  display: flex;
  margin-right: 0.125rem;
  border-bottom: rgba(237, 252, 75, 0.5) 0.0125rem solid;
}
.right {
  width: 47%;
  height: 98%;
  padding: 1rem 0 0 1rem;
  border-radius: 1rem;
  /* border: 1px blue solid; */
  box-shadow: 0 0 3px rgb(46, 43, 43);
}

.file-box {
  width: 100%;
  height: 94%;
  padding-right: 2%;
}
.file_name {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 4%;
}
.fileNameSpan {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 0.25rem;
  line-height: 0.25rem;
}
.tubiao {
  width: 0.3125rem;
  height: 0.3125rem;
  margin-right: 0.0625rem;
}
</style>



// WEBPACK FOOTER //
// src/views/File/index.vue